// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { Field, FormSection, formValueSelector } from "redux-form";

// helpers
import {
  required,
  email,
  numberLimit,
  phoneNumber,
  oneContactNumberRequired,
} from "../../helpers/validate";
import { removeUnwantedFiles } from "../../helpers/renderHelpers";

// redux actions
import { deleteFile } from "../../actions/formActions";

// enums
import { TITLE_LIST } from "../../config/enums";

// render components
import RenderField from "./RenderField";
import AddressSuggestion from "./AddressSuggestion/AddressSuggestion";

class RenderOwners extends React.Component {
  render() {
    const {
      fields,
      meta: { error, submitFailed },
      sameAsPrimaryContactApplicant,
      owners,
      appState,
      deleteFile,
    } = this.props;

    if (appState && appState.service.addresses.length < 1) {
      // have one owner address at load
      appState.service.addresses.push({
        id:
          "unitNoowners0addressunitNostreetNoowners0addressstreetNostreetNameowners0addressstreetNamesuburbowners0addresssuburbstateowners0addressstatepostcodeowners0addresspostcodecountryowners0addresscountry",
        value: "",
        isSelected: false,
        isManual: false,
        required: true,
      });
    }

    return (
      <div>
        {fields.map((owner, index) => (
          <div key={index}>
            <div className="sq-form-section-description">
              <h4>Owner #{index + 1}</h4>
            </div>
            {index === 0 && (
              <Field
                name="sameAsPrimaryContactApplicant"
                type="radiobox"
                component={RenderField}
                uncheckable
                templateList={[
                  {
                    name: "Same as primary contact details",
                    value: "primaryContact",
                  },
                  { name: "Same as applicant details", value: "applicant" },
                ]}
              />
            )}
            {!sameAsPrimaryContactApplicant || index > 0 ? (
              <div
                className={`sq-form-section ${
                  index === 0 && sameAsPrimaryContactApplicant ? "hidden" : ""
                }`}
              >
                <Field
                  name={`${owner}.title`}
                  type="select"
                  component={RenderField}
                  templateList={TITLE_LIST}
                  label="Title"
                  width="fourth"
                  validate={required}
                  required
                />
                <Field
                  name={`${owner}.givenName`}
                  type="text"
                  component={RenderField}
                  label="Given Name"
                  width="third"
                  validate={required}
                  required
                />
                <Field
                  name={`${owner}.familyName`}
                  type="text"
                  component={RenderField}
                  label="Family Name"
                  width="third"
                  validate={required}
                  required
                />
                <Field
                  name={`${owner}.organisationName`}
                  type="text"
                  component={RenderField}
                  label="Business or Organisation Name"
                />
                <Field
                  name={`${owner}.abn`}
                  type="text"
                  component={RenderField}
                  label="ABN"
                  width="half"
                  validate={numberLimit}
                />
                <Field
                  name={`${owner}.positionTitle`}
                  type="text"
                  component={RenderField}
                  label="Position Title"
                  width="half"
                />
                <Field
                  name={`${owner}.email`}
                  type="text"
                  component={RenderField}
                  label="Email"
                  validate={[required, email]}
                  required
                />
                <Field
                  name={`${owner}.telephone`}
                  type="text"
                  component={RenderField}
                  label="Telephone"
                  note={
                    !owners[index].telephone && !owners[index].mobile
                      ? "(At least one phone number is required)"
                      : null
                  }
                  width="half"
                  required={
                    !owners[index].telephone && !owners[index].mobile
                      ? "Required"
                      : null
                  }
                  validate={[phoneNumber, oneContactNumberRequired]}
                />
                <Field
                  name={`${owner}.mobile`}
                  type="text"
                  component={RenderField}
                  label="Mobile"
                  note={
                    !owners[index].telephone && !owners[index].mobile
                      ? "(At least one phone number is required)"
                      : null
                  }
                  width="half"
                  required={
                    !owners[index].telephone && !owners[index].mobile
                      ? "Required"
                      : null
                  }
                  validate={[phoneNumber, oneContactNumberRequired]}
                />
                <FormSection className="sq-form-section" name={`${owner}`}>
                  <AddressSuggestion
                    required={true}
                    form={this.props.form}
                    fields={{
                      unitNo: `${owner}.address.unitNo`,
                      streetNo: `${owner}.address.streetNo`,
                      streetName: `${owner}.address.streetName`,
                      suburb: `${owner}.address.suburb`,
                      state: `${owner}.address.state`,
                      postcode: `${owner}.address.postcode`,
                      country: `${owner}.address.country`,
                    }}
                  />
                </FormSection>
              </div>
            ) : null}
            {index > 0 && (
              <input
                type="button"
                className="sq-form-page-button"
                value="- Remove owner"
                onClick={() => {
                  for (var i = 0; i < appState.service.addresses.length; i++) {
                    if (
                      appState.service.addresses[i].id ===
                      `unitNoowners${index}addressunitNostreetNoowners${index}addressstreetNostreetNameowners${index}addressstreetNamesuburbowners${index}addresssuburbstateowners${index}addressstatepostcodeowners${index}addresspostcodecountryowners${index}addresscountry`
                    ) {
                      removeUnwantedFiles(
                        appState.service.attachments,
                        deleteFile,
                        index + 1
                      );

                      for (
                        var y = i;
                        y < appState.service.addresses.length;
                        y++
                      ) {
                        if (
                          appState.service.addresses[y].id.match("unitNoowners")
                        ) {
                          const numberToMatch = appState.service.addresses[
                            y
                          ].id.match(/([0-9]+)/);
                          appState.service.addresses[
                            y
                          ].id = appState.service.addresses[y].id.replace(
                            /([0-9]+)/g,
                            numberToMatch[0] - 1
                          );
                        }
                      }

                      appState.service.addresses.splice(i, 1);

                      break;
                    }
                  }
                  fields.remove(index);
                }}
              />
            )}
            {submitFailed && error && <span>{error}</span>}
          </div>
        ))}
        <input
          type="button"
          className="sq-form-page-button"
          value="+ Add another owner"
          onClick={() => {
            fields.push({});
            appState.service.addresses.push({
              id: `unitNoowners${fields.length}addressunitNostreetNoowners${fields.length}addressstreetNostreetNameowners${fields.length}addressstreetNamesuburbowners${fields.length}addresssuburbstateowners${fields.length}addressstatepostcodeowners${fields.length}addresspostcodecountryowners${fields.length}addresscountry`,
              value: "",
              isSelected: false,
              isManual: false,
              required: true,
            });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, formName) => {
  const selector = formValueSelector(formName.meta.form); // <-- same as form name
  let returnObj = {};
  const sameAsPrimaryContactApplicant = selector(
    state,
    "sameAsPrimaryContactApplicant"
  );
  const owners = selector(state, "owners");

  if (sameAsPrimaryContactApplicant && sameAsPrimaryContactApplicant.length) {
    returnObj.sameAsPrimaryContactApplicant = sameAsPrimaryContactApplicant;
  }
  if (owners && owners.length) {
    returnObj.owners = owners;
  }

  return returnObj;
};

const mapDispatchToProps = {
  deleteFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(RenderOwners);
